import React from 'react'
import PropTypes from 'prop-types'

import OnboardingButton from './OnboardingButton'
import StatusItem from './StatusItem'

import loginScreenContainer from './loginScreenContainer'
import usingOnboardingCard from './usingOnboardingCard'

import statusCompletedImage from 'resources/onboarding_status_complete.png'

class CompanyScreen extends React.Component {

  static propTypes = {
    onNextClicked: PropTypes.func.isRequired
  }

  render() {
    return (
      <div style={styles.container}>
        <div style={styles.content}>
          <StatusItem text='Account setup' icon={statusCompletedImage} style={{ marginBottom: 25 }} />
          <StatusItem text='Link to install the app sent' icon={statusCompletedImage} style={{ marginBottom: 25 }} />
          <StatusItem text='App not yet installed' style={{ marginBottom: 25 }} />
        </div>
        <OnboardingButton onButtonClicked={this.props.onNextClicked} />
      </div>
    )
  }

}

export default loginScreenContainer(usingOnboardingCard(CompanyScreen))

const styles = {

  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-around',
    height: '100%'
  },

  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'left'
  }

}



// WEBPACK FOOTER //
// ./src/login/OnboardingStatusScreen.js